<template>
  <div class="d-flex justify-end">
    <v-card>
       <v-overlay
          :absolute="true"
          :opacity="0.1"
          :value="false"
          v-if="annotations.length == 0"
        >
        </v-overlay>
      <v-navigation-drawer
        permanent
        :mini-variant="mini"

      >
        <v-list dark color="#AD8744">

          <v-list-item @click="mini=!mini">
            <v-list-item-content>
                
              <v-list-item-title class="text-h6">
               <v-icon >mdi-cog</v-icon>  Options
              </v-list-item-title>

            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list
          nav
          dense
        >
          <v-list-item link  @click.stop="getAnnotationsEntityCount()">
            <v-list-item-icon>
              <v-icon color="#AD8744">mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Annotations</v-list-item-title>
          </v-list-item>
          <v-list-item link @click.stop="getSeries()">
            <v-list-item-icon>
              <v-icon color="#AD8744" >mdi-chart-areaspline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Entities</v-list-item-title>
          </v-list-item>
          <v-list-item link  @click.stop="dialogdeleted = true">
            <v-list-item-icon>
              <v-icon color="#AD8744">mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Rejected</v-list-item-title>
          </v-list-item>
          <v-list-item link  @click.stop='$emit("update:labelsDialog", true)'>
            <v-list-item-icon>
              <v-icon color="#AD8744">mdi-palette</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Labels</v-list-item-title>
          </v-list-item>
          <v-list-item link  @click.stop="uploadFileDialog = true">
            <v-list-item-icon>
              <v-icon color="#AD8744">mdi-paperclip</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Upload File</v-list-item-title>
          </v-list-item>
          <v-list-item link  @click.stop="saveAnnotatorState">
            <v-list-item-icon>
              <v-icon color="#AD8744">mdi-content-save</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Save</v-list-item-title>
          </v-list-item>
              <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
            <v-list-item link v-on="on" v-bind="attrs">
            <v-list-item-icon>
              <v-icon color="#AD8744">mdi-export</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Export Annotated Corpus</v-list-item-title>
          </v-list-item>
      </template>
      <v-list>
        <v-list-item link  @click.stop="exportJSON">
          <v-list-item-title>JSON</v-list-item-title>
        </v-list-item>
        <v-list-item link  @click.stop="exportBIO">
          <v-list-item-title>BIO</v-list-item-title>
        </v-list-item>
        <v-list-item link  @click.stop="exportBILUO">
          <v-list-item-title>BILUO</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
        </v-list>
      </v-navigation-drawer>
    </v-card>



    <v-dialog
      v-model="labelsDialog"
      max-width="600px"
      @click:outside="$emit('update:labelsDialog', false);"
      @keydown.esc="$emit('update:labelsDialog', false);"
    >
      <v-card style="margin-top:30px">
        <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                        Labels' Options
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center"
              justify="center">
              <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <span class="text-md-body-1">Label1:</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  :label="label1"
                  disabled
                ></v-text-field>
                
              </v-col>
                            <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <v-text-field
                  v-model="keymodel1"
                  
                ></v-text-field>
                
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-btn width="150" :color="label1Color" @click="openLabel='1'; picker=label1Color; dialog3=true"></v-btn>
              </v-col>

              
            </v-row >
              <v-row class="py-0 my-0" align="center"
              justify="center">
              <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <span class="text-md-body-1">Label2:</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  :label="label2"
                  disabled
                ></v-text-field>
                
              </v-col>
                            <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <v-text-field
                  v-model="keymodel2"
                  
                ></v-text-field>
                
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-btn width="150" :color="label2Color" @click=" openLabel='2'; picker=label2Color; dialog3=true"></v-btn>
              </v-col>
            </v-row>

              <v-row class="py-0 my-0" align="center"
              justify="center">
              <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <span class="text-md-body-1">Label3:</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  :label="label3"
                  disabled
                ></v-text-field>
                
              </v-col>
                            <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <v-text-field
                  v-model="keymodel3"
                  
                ></v-text-field>
                
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-btn width="150" :color="label3Color" @click="openLabel='3'; picker=label3Color; dialog3=true"></v-btn>
              </v-col>
            </v-row>

              <v-row class="py-0 my-0" align="center"
              justify="center">
              <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <span class="text-md-body-1">Label4:</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  :label="label4"
                  disabled
                ></v-text-field>
                
              </v-col>
                            <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <v-text-field
                  v-model="keymodel4"
                  
                ></v-text-field>
                
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-btn width="150" :color="label4Color" @click="openLabel='4'; picker=label4Color; dialog3=true"></v-btn>
              </v-col>
            </v-row>

              <v-row class="py-0 my-0" align="center"
              justify="center">
              <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <span class="text-md-body-1">Label5:</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  :label="label5"
                  disabled
                ></v-text-field>
                
              </v-col>
                            <v-col
                cols="12"
                sm="6"
                md="2"
              >
                <v-text-field
                  v-model="keymodel5"
                  
                ></v-text-field>
                
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-btn width="150" :color="label5Color" @click="openLabel='5'; dialog3=true; picker=label5Color"></v-btn>

              </v-col>
            </v-row>
            <v-row class="pa-0 ma-0">
            <v-col justify="end" align="end" class="pa-0 ma-0">
              <v-btn
                color="blue darken-1"
                text
                @click="resetColors()"
              >
                Reset colors
              </v-btn>
            </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click='$emit("update:labelsDialog", false); closeDialog3()'
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click='$emit("update:labelsDialog", false); setKeys()'
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog
        v-model="dialog3"

        width="unset"
      >
        <v-card class="pa-3">
          <v-card-title>
          </v-card-title>
          <v-card-text>
          <v-color-picker
  dot-size="26"
  hide-inputs
  v-model="picker"
  mode="rgba"
  swatches-max-height="156"
></v-color-picker>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="setColor()"
            >
              accpet
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-dialog
      v-model="dialogdeleted"
      max-width="600px"
    >
      <v-card style="margin-top:30px">
        <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                        Rejected Sentences
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center"
              justify="center">
              <v-col
                cols="12"
                align="center"
              justify="center"
              >
              
<v-list v-if="deleted.length != 0">

    <v-list-item
          v-for="(item, i) in createSetences(deleted)"
          :key="i"
        >
          <v-list-item-content>
            <v-list-item-title > 
                 <v-btn
      color="success"
      class="mr-3 py-3"
      x-small
      @click="restore(i)"
    >
      <v-icon>
        mdi-restore
      </v-icon>
    </v-btn>
              <label class="font-weight-bold">{{i + " -   "}}</label>{{item}} 
         
    </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
</v-list>
<span v-else class="font-weight-bold"> Empty</span>
              </v-col>
            
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogdeleted = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



      <v-dialog
      v-model="annotationsDialog"
      max-width="900px"
      @click:outside="$emit('update:annotationsDialog', false);"
      @keydown.esc="$emit('update:annotationsDialog', false);"
    >
      <v-card style="margin-top:30px">
        <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                        Annotated Corpus
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center"
              justify="center">
              <v-col
                cols="12"
                align="center"
              justify="center"
              >

  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="annotationsEntityCount"
    item-key="batchNumber"
    show-select
    
    class="elevation-1"
  >

   <template v-slot:[`item.batchNumber`]="{  item }">
         <span class="font-weight-bold" >{{item.batchNumber}}</span>
    </template>
       <template v-slot:[`item.action`]="{  index }">
          <v-btn
      color="#AD8744"
      dark
      class="mr-3 py-3"
      x-small
      @click="selectItems(index)"
    >
      <v-icon>
        mdi-pencil
      </v-icon>
    </v-btn>
    </template>
  </v-data-table>

  
              </v-col>
            
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
                        
          <v-spacer></v-spacer>
          <v-btn  type='submit' @click="train()"> <v-icon  color="#AD8744" class="pr-2">mdi-arrow-right-drop-circle</v-icon>  Train </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('update:annotationsDialog', false);"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


     <v-dialog
      v-model="dialogEntities"
      max-width="600px"
    >
      <v-card style="margin-top:30px">
        <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                        Entities List
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
        <v-card-text>
          <v-container>
               <v-row class="mb-3">
          <v-col class="ml-3">

                      <p class="secondary--text font-weight-medium ma-0"  >

              Total: {{series[0].data.reduce((a, b) => a + b, 0)}}
            </p> 

            <p class="secondary--text font-weight-medium ma-0"  >

               Organizacao: {{series[0].data[0]}}
            </p> 
            <p class="secondary--text font-weight-medium ma-0"  >
               Data: {{series[0].data[4]}}
            </p> 
         
          </v-col>
          <v-col>
                        <p class="secondary--text font-weight-medium ma-0"  >
                          
              Local: {{series[0].data[2]}}
            </p> 

            <p class="secondary--text font-weight-medium ma-0"  >
               Pessoa: {{series[0].data[1]}}
            </p> 
            <p class="secondary--text font-weight-medium ma-0"  >
               Profissão/Título: {{series[0].data[3]}}
            </p> 
          </v-col>
          </v-row>

<VueApexCharts ref="realtimeChart" height="350" type="bar" :options="options" :series="series"></VueApexCharts>

          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogEntities = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


       <v-dialog
      v-model="uploadFileDialog"
      max-width="600px"
    >
      <v-card style="margin-top:30px">
        <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                        Entities List
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
        <v-card-text>
            <FileDragDrop @readLocalFile="readLocalFile"/>
        </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import VueApexCharts from 'vue-apexcharts'
import FileDragDrop from '@/components/FileDragDrop.vue'

export default {
  components:{
    VueApexCharts,
    FileDragDrop
    },
  props: ['label1Color',
  'label2Color',
  'label3Color',
  'label4Color',
  'label5Color',
  'label1',
  'items',
  'label2',
  'label3',
  'label4',
  'label5',
  'label1Key',
  'label2Key',
  'label3Key',
  'label4Key',
  'label5Key',
  'annotationsDialog',
  'labelsDialog',
  'annotations',
  'deleted'],
 data() {
    return {
        mini:true,
        selected: [],
        picker:"",
        dialogEntities:false,
        uploadFileDialog:false,
        dialog3:false, //picker
        dialogdeleted:false,
        keymodel1:this.label1Key,
        deletedIndex:0,
        keymodel2:this.label2Key,
        keymodel3:this.label3Key,
        keymodel4:this.label4Key,
        annotationsEntityCount: [],
        keymodel5:this.label5Key,
       headers: [
                   {
            text: 'Batch Number',
            align: 'start',
            value: 'batchNumber',
          },
          { text: "Batch Size", value: 'batchSize' },
          { text: this.label1, value: 'label1N' },
          { text: this.label2, value: 'label2N' },
          { text: this.label3, value: 'label3N' },
          { text: this.label4, value: 'label4N' },
          { text: this.label5, value: 'label5N' },
          { text: "Total", value: 'total' },
          { text: "Action", value: 'action' },
        ],

        openLabel:"",
         options: {
            plotOptions: {
              bar: {
                borderRadius: 10,
                dataLabels: {
                  position: 'center', // top, center, bottom
                },
              }
            },
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: ["Organização","Pessoa","Local","Profissão","Data"],
        },
         title: {
              text: 'Number of Annotated Entities',
              floating: true,
              align: 'center',
              style: {
                color: '#444'
              }
            },
      },
      series: [{
        name: 'Entities',
        color:"#AD8744",
        data: [0,0,0,0,0]
      }]
    }
  },

  created() {

  },
  methods:{ 
      readLocalFile(file){
        if(!confirm("The current annotated corpus will be lost!")) return
        this.$emit("readLocalFile", file);
        this.uploadFileDialog = false

      },

      exportJSON(){
        this.$emit("exportJSON");

      },
      exportBIO(){
        this.$emit("exportBIO");

      },
      exportBILUO(){
        this.$emit("exportBILUO");

      },
      saveAnnotatorState(){
        this.$emit("saveAnnotatorState");

      },

      train(){
          if(this.selected.length == 0)
            if(!confirm("Are you sure you want to train the ML model without any annotated batch?")) 
              return;
        this.$emit("train",this.selected);
        this.$emit('update:annotationsDialog', false);

      },
      createSetences: function(array){
    var sentences= []
    var i = 0;
    var j = 0;
      for(i = 0; i<array.length ; i++){
        var aux = ""
          for(j = 0; j < array[i].length; j++){
            aux += " "+ array[i][j][0]
          }
          sentences.push(aux)
      }
      return sentences;          
      },
      setColor(){
        switch (this.openLabel) {
          case '1':
            this.label1Color = this.picker
            this.$emit('update:label1Color', this.label1Color);
            break;
          case '2':
            this.label2Color = this.picker
            this.$emit('update:label2Color', this.label2Color);
            break;
          case '3':
            this.label3Color = this.picker
            this.$emit('update:label3Color', this.label3Color);
            break;
          case '4':
            this.label4Color = this.picker
            this.$emit('update:label4Color', this.label4Color);
            break;
          case '5':
            this.label5Color = this.picker
            this.$emit('update:label5Color', this.label5Color);
            break;
          }
              this.dialog3 = false
        },
        setKeys(){
          this.label1Key =this.keymodel1
          this.label2Key =this.keymodel2
          this.label3Key =this.keymodel3
          this.label4Key =this.keymodel4
          this.label5Key =this.keymodel5
          this.$emit('update:label1Key', this.label1Key);
          this.$emit('update:label2Key', this.label2Key);
          this.$emit('update:label3Key', this.label3Key);
          this.$emit('update:label4Key', this.label4Key);
          this.$emit('update:label5Key', this.label5Key);
        },
        closeDialog3(){
          this.keymodel1 =this.label1Key
          this.keymodel2 =this.label2Key
          this.keymodel3 =this.label3Key
          this.keymodel4 =this.label4Key
          this.keymodel5 =this.label5Key
        },
        resetColors(){
            this.label1Color="#ddd" //#E4E7D2 #ddd
            this.label2Color="#7AECEC"
            this.label3Color="#AA9CFC"
            this.label4Color="#FECA74"
            this.label5Color="#BFE1D9"
            this.$emit('update:label1Color', this.label1Color);
            this.$emit('update:label2Color', this.label2Color);
            this.$emit('update:label3Color', this.label3Color);
            this.$emit('update:label4Color', this.label4Color);
            this.$emit('update:label5Color', this.label5Color);
        },
        restore(i){
          this.$emit("restore",i)
        },
        getSeries(){
            var aux = this.countEntities(this.items)
           this.series = [{
                              data: aux,
                              name: 'Entities',
                              color:"#AD8744",
                          }]
        this.dialogEntities = true
      },
      countEntities(array){
        var aux = [0,0,0,0,0]
          array.forEach( line =>{ 
          aux[0] += line.filter(token =>token[2] == "Organizacao" && token[1] == "B").length
          aux[1] += line.filter(token =>token[2] == "Pessoa" && token[1] == "B").length
          aux[2] += line.filter(token =>token[2] == "Local" && token[1] == "B").length
          aux[3] += line.filter(token =>token[2] == "Profissao" && token[1] == "B").length
          aux[4] += line.filter(token =>token[2] == "Data" && token[1] == "B").length
        })
        return aux
      },
      getAnnotationsEntityCount(){
        var counts = []
        console.log(this.annotations)
        this.annotations.forEach((ann,i) => {
            var count = []
            count = this.countEntities(ann)
            counts.push({
              batchNumber: i,
              batchSize: ann.length,
              label1N: count[0],
              label2N: count[1],
              label3N: count[2],
              label4N: count[3],
              label5N: count[4],
              total: count.reduce((a, b) => a + b, 0)
              })

          })

        this.annotationsEntityCount = counts
        this.$emit('update:annotationsDialog', true);
      },
      selectItems(index){
        this.$emit('selectItems',index)
      }
        
    
  }
};
</script>


